import { Component, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
  fallbackMessage?: string;
}

interface State {
  hasError: boolean;
}

export default class PaymentErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  handleRetry = () => {
    this.setState({ hasError: false });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="rounded-2xl border border-red-100 bg-red-50/80 px-4 py-4 text-center">
          <p className="text-sm text-red-700">
            {this.props.fallbackMessage ?? 'Payment form unavailable.'}
          </p>
          <button
            type="button"
            onClick={this.handleRetry}
            className="mt-2 text-sm font-medium text-red-800 underline hover:text-red-900"
          >
            Try again
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}
